export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA = "FETCH_DATA";
export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
export const FILTER_CATEGORY = "FILTER_CATEGORY";
export const SET_CURRENT_QUIZ_ID = "SET_CURRENT_QUIZ_ID";
export const SET_CURRENT_QUIZ = "SET_CURRENT_QUIZ";
export const GO_TO_PREVIOUS_PAGE = "GO_TO_PREVIOUS_PAGE";
export const GO_TO_NEXT_PAGE = "GO_TO_NEXT_PAGE";
export const OPTION_SELECTED = "OPTION_SELECTED";
export const CALCULATE_SCORE = "CALCULATE_SCORE";
export const RESET_QUIZ = "RESET_QUIZ";
export const QUIT_QUIZ = "QUIT_QUIZ";
export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
